<div class="login-form p-[0.5em] bg-[#fff] w-full ml-auto rounded-[30px] lg:px-[3em] py-[6em] text-center">
    <img src="/assets/images/medease-logo.png" alt="" class="w-[150px]">
    <form class="" [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="user-details mt-10 flex flex-col">
            <mat-form-field appearance="fill" color="primary">
                <mat-label>Phone or E-mail</mat-label>
                <input type="text" matInput formControlName="username" autoFocus  (keydown.enter)="login()">
                <!-- <div *ngIf="errors.phoneoremail" class="text-red-800 text-sm">
                    <div *ngFor="let error of errors.phoneoremail">{{ error }}</div>                                  
                </div> -->
                <!-- <mat-error *ngIf="let error of errors.phoneoremail" class="mb-2 text-sm">Please enter a valid name</mat-error> -->
            </mat-form-field>
            <mat-form-field appearance="fill" color="primary">
                <mat-label>Password</mat-label>
                <input [type]="hide() ? 'password' : 'text'" matInput formControlName="password" autocomplete="off"  (keydown.enter)="login()">
                <button mat-icon-button matSuffix (click)="clickEvent($event)" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide()">
                    <mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                <!-- <mat-error *ngIf="errors.password" class="text-red-800 text-sm">
                    <div *ngFor="let error of errors.password">{{ error }}</div>                                  
                </mat-error> -->
            </mat-form-field>
        </div>  
        <div *ngIf="errors.phoneoremail" class="text-red-700 text-sm text-center mb-2">{{errors.phoneoremail}}</div>     
        <div *ngIf="errors.password" class="text-red-700 text-sm text-center mb-2">{{errors.password}}</div>  
        <div *ngIf="!errors.phoneoremail && !errors.password" class="text-red-700 text-sm text-center mb-2">{{errors}}</div>  

        <!-- <div class="text-end">
            <button class="text-sm text-[#677db9] border-b-[1px] border-[#677db9] bg-transparent p-0 cursor-pointer">Forgot
                password?</button>
        </div> -->
        <!-- <button (click)="togglePasswordVisibility($event)">
            {{ hide() ? 'Show Password' : 'Hide Password' }}
          </button> -->
        <button type="submit" loadingButton [loading]="isLoading" [disabled]="isLoading"
            class="book-now rounded-[12px] font-bold text-sm px-4 py-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-15 p-2 text-center text-white cursor-pointer mt-10 w-full">
            Login
        </button>
    </form>

    <div class="mt-10">
        Don't have account?
        <button class="text-sm text-[#677db9] border-b-[1px] border-[#677db9] bg-transparent p-0 cursor-pointer" (click)="goToSignUp()">Create an
            Account</button>
    </div>
</div>
<ngx-spinner bdColor="rgba(256, 256, 256, 0.7)" size="default" color="#6eabc6" type="ball-spin-fade"
[fullScreen]="true">
<p style="color: black"> Please wait... </p>
</ngx-spinner>